var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3386 7.07138C27.9041 7.63697 27.9041 8.55396 27.3386 9.11954L17.0629 19.3953C16.4974 19.9608 15.5804 19.9608 15.0148 19.3953L8.54822 12.9288C7.98262 12.3632 7.98262 11.4462 8.54822 10.8806L18.824 0.60486C19.3896 0.0392653 20.3065 0.0392653 20.8721 0.60486L27.3386 7.07138Z",
    fill: "#4A6DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4528 7.07138C20.0184 7.63697 20.0184 8.55396 19.4528 9.11954L9.17715 19.3953C8.61158 19.9608 7.69459 19.9608 7.129 19.3953L0.662477 12.9288C0.0968825 12.3632 0.0968825 11.4462 0.662477 10.8806L10.9382 0.60486C11.5038 0.0392653 12.4208 0.0392653 12.9864 0.60486L19.4528 7.07138Z",
    fill: "#2EB9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany04);
export default __webpack_public_path__ + "static/media/company-04.7ebe3611891dd2bdfb24ee537125ac74.svg";
export { ForwardRef as ReactComponent };